<template>
  <base-dialog
    :show-close="true"
    :visible.sync="visible"
    width="540px"
    class="code-template-dialog"
  >
    <template v-slot:header>设置模板</template>
    <div class="template-setting">
      <div class="template-item">
        <div class="item-title">短信签名内容</div>
        <el-input v-model="signInfo"></el-input>
      </div>
      <div class="template-item">
        <div class="item-title">短信模板ID</div>
        <el-input v-model="templateCodeInfo"></el-input>
      </div>
      <div class="template-item">
        <div class="item-title">验证码变量</div>
        <el-input v-model="verifyCode"></el-input>
      </div>
      <div style="margin-top: 30px;">
        <div class="var-title">模板变量</div>
        <div class="key-value" v-if="!_.isEmpty(params)">
          <div style="width: 43%">短信模板变量</div>
          <div style="flex: 1">工作表变量</div>
        </div>
        <div style="max-height: 150px; padding-right: 12px;" v-ps>
          <div v-for="(param, index) in params" :key="index">
            <div class="template-var">
              <div class="item">
                <div style="display: flex; align-items: center; position: relative;">
                  <span class="required">
                    *
                  </span>
                  <el-input v-model="param.code" placeholder="请输入变量"></el-input>
                </div>
              </div>
              <span class="divider">→</span>
              <div class="item">
                <normal-select
                  :select-list="varList"
                  :selected-item.sync="param.sheetVar"
                ></normal-select>
              </div>
              <span style="margin-left: 6px;" @click="delParam(index)">
                <svg-icon
                  style="font-size: 18px;"
                  icon-class="workflow_script_del-script1"
                ></svg-icon>
              </span>
            </div>
          </div>
          <div class="mTop10">
            <span class="add-item" @click="addParam">+ 添加变量</span>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="cancel">取消</base-button>
        <base-button type="primary" @click="submit">保存</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import mixin from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/mixin"

export default {
  name: "CodeTemplateDialog",
  components: {
    NormalSelect,
    BaseDialog,
    BaseButton
  },
  props: {
    sign: String,
    templateCode: String,
    vars: Object,
    varList: Array
  },
  data() {
    return {
      visible: false,
      signInfo: "",
      templateCodeInfo: "",
      varsInfo: {},
      param: {
        code: "",
        sheetVar: ""
      },
      params: [],
      verifyCode: ""
    }
  },
  mixins: [mixin],
  methods: {
    open() {
      this.signInfo = this.sign
      this.templateCodeInfo = this.templateCode
      this.varsInfo = this.vars
      this.params = []
      if (!this._.isEmpty(this.varsInfo)) {
        this._.keys(this.varsInfo).forEach(key => {
          if (this.varsInfo[key].value === "code") {
            this.verifyCode = key
          } else {
            this.params.push({ code: key, sheetVar: this.varsInfo[key].value })
          }
        })
      }
      this.visible = true
    },
    getVarsInfo() {
      if (this.params.length) {
        this.params.forEach(param => {
          this.$set(this.varsInfo, param.code, { var: true, value: param.sheetVar })
        })
      }
      this.$set(this.varsInfo, this.verifyCode, { var: true, value: "code" })
    },
    submit() {
      if (!this.signInfo) {
        this.$message.error("短信签名内容必填")
        return
      }
      if (!this.templateCodeInfo) {
        this.$message.error("短信模板ID必填")
        return
      }
      if (!this.verifyCode) {
        this.$message.error("验证码变量必填")
        return
      }
      if (!this.verifyPairs(this.params, "submit")) return
      if (this.params.map(param => param.code).includes(this.verifyCode)) {
        this.$message.error("验证码变量不能与模板变量key重复")
        return
      }
      this.getVarsInfo()
      this.$emit("submit", this.signInfo, this.templateCodeInfo, this.varsInfo)
      this.visible = false
    },
    cancel() {
      this.visible = false
    },
    delParam(index) {
      this.params.splice(index, 1)
    },
    addParam() {
      if (!this.verifyPairs(this.params, "add")) return
      this.params.push(this.$options.data().param)
    }
  }
}
</script>

<style lang="scss" scoped>
.code-template-dialog {
  .template-setting {
    color: #606266;
    flex: 1;
    margin: 10px;
    .template-item {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      .item-title {
        width: 120px;
      }
    }
    .var-title {
      font-weight: bold;
      margin-bottom: 22px;
    }
    .key-value {
      display: flex;
      text-align: center;
    }
    .template-var {
      display: flex;
      align-items: center;
      .item {
        text-align: center;
        flex: 1;
        .required {
          color: red;
          z-index: 10;
          position: absolute;
          margin-left: 8px;
        }
      }
      .divider {
        padding: 10px;
        width: 12px;
      }
    }
    .add-item {
      cursor: pointer;
      color: #9e9e9e;
      &:hover {
        color: #1e88e5;
      }
    }
  }
}
</style>
